export class Funcionario {
    id: number;
    pessoaId: number;
    ativo: boolean;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/funcionarios/funcionario.model.ts
 **/